// extracted by mini-css-extract-plugin
module.exports = {"buttonNext":"ButtonNext_buttonNext__1Moxy"};